<template>
	<div class="dropdown is-hoverable" :class="alignmentClass">
		<div class="dropdown-trigger">
			<button class="button" aria-haspopup="true" :aria-controls="dropdownName">
				<strong>{{ buttonText || (selectedOption && getOptionText(selectedOption)) || optionCaption }}</strong>
				<span class="icon is-small">
					<font-awesome-icon :icon="['far', 'angle-down']"></font-awesome-icon>
				</span>
			</button>
		</div>
		<div class="dropdown-menu">
			<div class="dropdown-content">
				<a
					href="#"
					class="dropdown-item"
					v-for="(option, index) in options"
					:class="{ 'is-active': option == selectedOption }"
					@click.prevent="setSelectedOption(index)"
					>{{ getOptionText(option) }}</a
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["dropdownName", "alignment", "buttonText", "options", "handleSelectedOption", "optionCaption", "optionText"],
	data() {
		return {
			selectedOption: null,
		}
	},
	computed: {
		alignmentClass() {
			if (this.alignment == "left") {
				return "is-left"
			}
			if (this.aligmnet == "right") {
				return "is-right"
			}
			return "is-right"
		},
	},
	methods: {
		getOptionText(option) {
			if (this.optionText) {
				return this.optionText(option)
			}

			return option.text || option
		},
		setSelectedOption(index) {
			if (this.handleSelectedOption) {
				this.handleSelectedOption(index, this.options[index])
			}

			this.selectedOption = this.options[index]
		},
	},
	mounted() {
		if (!this.optionCaption) {
			this.setSelectedOption(0)
		}
	},
}
</script>
